import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import { useEffect } from 'react';
import SelfInspectInput from './Inputs/SelfInspectInput';
import SelfInspectBackButton from '../../pages/self-inspect/SelfInspectBackButton';
import SelfInspectButton from './SelfInspectButton';
import SelfInspectQuestionLabel from './SelfInspectQuestionLabel';

const styles = theme => ({
  //
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },

  title: {
    fontSize: '2rem',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 20,
  },

  answerContainer: {
    fontSize: '1.25rem',
    width: '100%',
    textAlign: 'center',
    marginBottom: 10,
  },

  actionContainer: {
    //marginTop: 20,
    flexGrow: 0,
    flexBasis: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    //background: 'orange',
    paddingTop: 5,
    paddingBottom: 5,
  },
});

const MultiInputBoxCard = withStyles(styles)(props => {
  const {
    // dynamic values
    cardNumber,
    questions,
    title,
    navLabel,
    navLabelDisabled,
    selfInspectIntro,
    //
    // functions
    updateAnswer,
    confirmAnswer,
    //
    // other
    classes,
    inputProps,
    goBack,
    hideBackButton,
    debug,
  } = props;

  debug && console.log('props', props);

  const handleChange = questionId => evt => {
    const value = evt.target.value;

    updateAnswer({
      cardNumber,
      questionId,
      value,
    });
  };

  const handleYes = () => {
    confirmAnswer({
      cardNumber,
    });
  };

  const renderQuestions = () => {
    return questions.map(({ questionId, type, questionLabel, answerValue, ...inputProps }) => (
      <div key={questionId} className={classes.answerContainer}>
        <SelfInspectInput
          {...inputProps}
          label={questionLabel}
          type={type}
          value={answerValue}
          onChange={handleChange(questionId)}
        />
      </div>
    ));
  };

  return (
    <div className={classes.container}>
      <div className={classes.container} id="multiInputContainer">
        {!!title && (
          <SelfInspectQuestionLabel isHeader style={{ marginBottom: 20 }}>
            {title}
          </SelfInspectQuestionLabel>
        )}

        {renderQuestions()}
      </div>
      <div className={classnames(classes.actionContainer)}>
        {!hideBackButton && <SelfInspectBackButton onClick={goBack} className="flex-1 mr-20" />}

        <SelfInspectButton
          label={
            selfInspectIntro.remote ? navLabel : !questions.some(q => q.error === true) ? navLabel : navLabelDisabled
          }
          onClick={handleYes}
          disabled={questions.some(q => q.error === true) && !selfInspectIntro.remote}
          className="flex-1"
        />
      </div>
    </div>
  );
});

MultiInputBoxCard.propTypes = {};

MultiInputBoxCard.defaultProps = {};

export default MultiInputBoxCard;
